<h2 mat-dialog-title>{{ 'actions.change_password' | translate }}<span class="icon-close icon-Cross" mat-dialog-close></span></h2>
<mat-dialog-content>
  <form class="form-modal" [formGroup]="form">
    <mat-form-field>
      <mat-label>{{ 'form.fields.current_password' | translate }}</mat-label>
      <input
        [type]="additionalService.isPasswordVisible('oldPassword') ? 'text' : 'password'"
        formControlName="oldPassword"
        autocomplete="off"
        matInput
        [placeholder]="'form.fields.current_password_placeholder' | translate" />

      <span
        (click)="additionalService.togglePasswordVisibility('oldPassword')"
        class="input-icon-suffix"
        [ngClass]="additionalService.isPasswordVisible('oldPassword') ? 'icon-Show-Password' : 'icon-Hide-Password'"
        matSuffix></span>
    </mat-form-field>

    <mat-form-field>
      <mat-label>{{ 'form.fields.new_password' | translate }}</mat-label>
      <input
        [type]="additionalService.isPasswordVisible('newPassword') ? 'text' : 'password'"
        formControlName="newPassword"
        autocomplete="off"
        matInput
        [placeholder]="'form.fields.new_password_placeholder' | translate" />

      <span
        (click)="additionalService.togglePasswordVisibility('newPassword')"
        class="input-icon-suffix"
        [ngClass]="additionalService.isPasswordVisible('newPassword') ? 'icon-Show-Password' : 'icon-Hide-Password'"
        matSuffix></span>

      <mat-error *ngIf="form.get('newPassword')!.hasError('minlength') || form.get('newPassword')!.hasError('maxlength')"
        >{{
          'form.errors.password_length'
            | translate
              : { minLength: RULES.PASSWORD_MIN_LENGTH, maxLength: RULES.PASSWORD_MAX_LENGTH, currentLength: form.get('newPassword')?.value?.length || 0 }
        }}
      </mat-error>
    </mat-form-field>

    <mat-form-field>
      <mat-label>{{ 'form.fields.confirm_password' | translate }}</mat-label>
      <input
        [type]="additionalService.isPasswordVisible('confirmPassword') ? 'text' : 'password'"
        formControlName="confirmPassword"
        autocomplete="off"
        matInput
        [placeholder]="'form.fields.confirm_password_placeholder' | translate" />

      <span
        (click)="additionalService.togglePasswordVisibility('confirmPassword')"
        class="input-icon-suffix"
        [ngClass]="additionalService.isPasswordVisible('confirmPassword') ? 'icon-Show-Password' : 'icon-Hide-Password'"
        matSuffix></span>
    </mat-form-field>

    <mat-error class="general-form-error" *ngIf="form.errors?.['passwordMismatch'] && form.get('confirmPassword')!.touched"
      >{{ 'form.errors.password_mismatch' | translate }}
    </mat-error>
  </form>
  <app-loader></app-loader>
</mat-dialog-content>
<mat-dialog-actions [align]="'end'">
  <button class="btn-main btn-secondary-purple btn-xl" mat-dialog-close>{{ 'actions.cancel' | translate }}</button>
  <button class="btn-main btn-primary btn-xl" (click)="onSubmit()" [matTooltip]="!form.valid ? ('messages.form_submit_tooltip' | translate) : null">
    {{ 'actions.save' | translate }}
  </button>
</mat-dialog-actions>
